import {type ComboBoxOption, setToComboBoxOption } from "../../../utils/ComboBoxMapping";
import type IPayloadConstructionStateUpdate from "../../constructionsNew/types/IPayloadConstructionStateUpdate";
import type ConstructionListItem from "../types/ConstructionListItem";

export const getConstructionsFilterData = (
  constructions: ConstructionListItem[],
): [ComboBoxOption[], ComboBoxOption[]] => {
  const uniqueLocationCodes = new Set<string>();
  const uniqueCreatedBy = new Set<string>();

  constructions?.forEach(construction => {
    uniqueCreatedBy.add(construction.createdBy);
    uniqueLocationCodes.add(construction.locationCode);
  });

  const locationCodes = setToComboBoxOption(uniqueLocationCodes);
  const createdBy = setToComboBoxOption(uniqueCreatedBy);

  return [locationCodes, createdBy];
};

export const updateStateCollections = (
  payload: IPayloadConstructionStateUpdate[],
  state: ConstructionListItem[]
) : ConstructionListItem[] => {
  payload.forEach(item => {
    const index = state.findIndex(a => a.id === item.id);
    if (index !== -1) {
      state[index] = {
        ...state[index],
        status: item.status,
      };
    }
  });
  return state;
};

const useSliceNewHook = (): {
    updateStateCollections: (
        payload: IPayloadConstructionStateUpdate[],
        state: ConstructionListItem[]
    ) => ConstructionListItem[];
    getConstructionsFilterData: (
        constructions: ConstructionListItem[],
    ) => [ComboBoxOption[], ComboBoxOption[]];
} => ( { updateStateCollections, getConstructionsFilterData } );
export default useSliceNewHook;